import { forOwn } from './index';
/**
 *  @internal Used to define if an enum includes the provided
 *  value, as TypeScript transpiles enums to objects.
 */
export default function enumIncludes(enumValues, value) {
    if (enumValues.constructor !== Object) {
        throw new TypeError(`EnumIncludes util: provided enum is not an Object: ${enumValues}`);
    }
    if (!value) {
        throw new Error('EnumIncludes util: value to check not provided');
    }
    let includes = false;
    forOwn(enumValues, (enumValue) => {
        if (enumValue === value) {
            includes = true;
        }
        return !includes;
    });
    return includes;
}
//# sourceMappingURL=enumIncludes.js.map